
export const cyberStyles = (theme) => {
    const isDarkMode = theme.palette.typeBackground === 'dark';

    return {
        globalRoot: {
            minHeight: '100vh',
            background: isDarkMode
                ? 'radial-gradient(circle at center, #1a2a3a 0%, #090d11 100%)'
                : '#ffffff',
            display: 'flex',
            color: isDarkMode ? '#ffffff' : '#000000',
        },
        settingRoot: {
            display: 'flex',
            height: '100vh',
            overflow: 'hidden',
            background: isDarkMode
                ? 'radial-gradient(circle at center, #1a2a3a 0%, #090d11 100%)'
                : '#f4f7f9',
            transition: 'background 0.3s ease',
        },
        glassPanel: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(20px)' : 'none',
            borderRadius: '24px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.15)' : '#e0e0e0'}`,
            boxShadow: isDarkMode
                ? '0 25px 50px rgba(0,0,0,0.5)'
                : '0 10px 30px rgba(0,0,0,0.05)',
        },
        container: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(6),
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(10px)' : 'none',
            borderRadius: '16px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.15)' : '#eeeeee'}`,
            boxShadow: isDarkMode
                ? '0 8px 32px 0 rgba(0, 0, 0, 0.4)'
                : '0 4px 20px rgba(0, 0, 0, 0.05)',
            overflow: 'auto',
        },
        accordion: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.03)' : '#fcfcfc',
            backdropFilter: isDarkMode ? 'blur(10px)' : 'none',
            border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#eeeeee'}`,
            borderRadius: '12px !important',
            marginBottom: theme.spacing(2),
            '&:before': { display: 'none' },
        },
        neonInput: {
            marginBottom: theme.spacing(1),
            '& input': {
                color: isDarkMode ? '#ffffff' : '#000000', // Forces text to white in dark mode
            },
            '& .MuiFilledInput-root': {
                backgroundColor: isDarkMode ? 'rgba(0, 0, 0, 0.2)' : '#f5f5f5',
                border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.3)' : '#dddddd'}`,
                borderRadius: '8px',
                color: isDarkMode ? '#fff' : '#000',
                transition: 'all 0.3s ease',
                '&:hover': {
                    backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : '#eeeeee',
                    borderColor: isDarkMode ? '#00f2ff' : '#000000',
                },
                '&.Mui-focused': {
                    backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : '#ffffff',
                    borderColor: isDarkMode ? '#00f2ff' : '#000000',
                    boxShadow: isDarkMode ? '0 0 12px rgba(0, 242, 255, 0.4)' : '0 0 8px rgba(0,0,0,0.1)',
                },
                '&:before, &:after': { display: 'none' },
            },
            '& .MuiInputLabel-root': { color: isDarkMode ? '#00f2ff' : '#000000', opacity: 0.7 },
            '& .MuiSvgIcon-root': { color: isDarkMode ? '#00f2ff' : '#000000' },
        },
        primaryGlowBtn: {
            backgroundColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            color: isDarkMode ? '#000000' : '#ffffff',
            borderRadius: '12px',
            padding: theme.spacing(1.5),
            fontWeight: 800,
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            boxShadow: isDarkMode ? '0 0 20px rgba(0, 242, 255, 0.4)' : theme.shadows[4],
            transition: 'all 0.3s ease',
            '&:hover': {
                backgroundColor: isDarkMode ? '#00d4e0' : theme.palette.primary.dark,
                boxShadow: isDarkMode ? '0 0 30px rgba(0, 242, 255, 0.6)' : theme.shadows[8],
                transform: 'translateY(-2px)',
            },
            '&:disabled': {
                backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.12)',
                color: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.26)',
                boxShadow: 'none',
            }
        },
        uploadButton: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.03)',
            color: isDarkMode ? '#ffffff' : '#1a1a1a',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.3)' : 'rgba(0, 0, 0, 0.15)'}`,
            borderRadius: '12px',
            padding: theme.spacing(1.5),
            fontWeight: 700,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.08)' : 'rgba(0, 0, 0, 0.05)',
                borderColor: '#00f2ff',
                boxShadow: isDarkMode ? '0 0 15px rgba(0, 242, 255, 0.2)' : 'none',
            },
            '& .MuiButton-startIcon': {
                color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            }
        },
        headerCell: {
            color: isDarkMode ? '#00f2ff' : '#000000',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            borderBottom: `2px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#eeeeee'}`,
            backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : '#fafafa',
        },
        row: {
            cursor: 'pointer',
            transition: 'background-color 0.3s',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.08) !important' : '#f5f5f5 !important',
            },
            '& .MuiTableCell-root': {
                color: isDarkMode ? '#ffffff' : '#000000',
                borderBottom: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#eeeeee'}`,
            }
        },
        paper: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(12px)' : 'none',
            borderRadius: '16px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.15)' : '#eeeeee'}`,
            boxShadow: isDarkMode ? '0 8px 32px 0 rgba(0, 0, 0, 0.6)' : '0 8px 32px rgba(0,0,0,0.05)',
            overflow: 'hidden',
            '& .MuiDataGrid-root': {
                border: 'none',
                color: isDarkMode ? '#ffffff' : '#000000',
                '& .MuiDataGrid-cell': {
                    borderBottom: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#eeeeee'}`,
                },
                '& .MuiDataGrid-columnHeader': {
                    backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.07)' : '#fafafa',
                    color: isDarkMode ? '#00f2ff' : '#000000',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                },
                '& .MuiDataGrid-footerContainer': {
                    borderTop: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#eeeeee'}`,
                    color: isDarkMode ? '#ffffff' : '#000000',
                },
            },
            '& .MuiDataGrid-selectedRowCount': {
                color: isDarkMode ? '#00f2ff' : '#000000',
            },
            '& .MuiTablePagination-root': {
                color: isDarkMode ? '#00f2ff' : '#000000',
            },
            '& .MuiTablePagination-selectIcon': {
                color: isDarkMode ? '#00f2ff' : '#000000',
            },
            '& .MuiIconButton-root.Mui-disabled': {
                color: isDarkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
            },
            '& .MuiIconButton-root': {
                color: isDarkMode ? '#00f2ff' : '#000000',
            }
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
            height: '100%',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-thumb': {
                background: isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#cccccc',
                borderRadius: '10px'
            },
        },
        contentMainPage: {
            flexGrow: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: isDarkMode ? 'rgba(0, 0, 0, 0.87)' : '#ffffff',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column-reverse',
            }
        },
        summaryText: {
            fontWeight: 'bold',
            color: isDarkMode ? '#ffffff' : '#000000',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontSize: '0.85rem',
        },
        columnAction: {
            width: theme.spacing(1),
            padding: theme.spacing(0, 1),
            '& .MuiSvgIcon-root': {
                color: isDarkMode ? '#00f2ff' : '#000000',
            }
        },
        checkboxLabel: {
            color: isDarkMode ? '#00f2ff' : '#000000',
            '& .MuiCheckbox-root': {
                color: isDarkMode ? 'rgba(0, 242, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)',
            },
            '& .Mui-checked': {
                color: isDarkMode ? '#00f2ff !important' : '#000000 !important',
            },
        },
        appBarWrapper: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            zIndex: theme.zIndex.drawer + 1,
        },
        toolbarSpacer: {
            ...theme.mixins.toolbar,
        },
        details: {
            flexDirection: 'column',
            padding: theme.spacing(4),
        },
        fieldWrapper: {
            marginBottom: theme.spacing(3),
            width: '100%',
        },
        table: {
            minWidth: 650,
            backgroundColor: 'transparent',
        },

        //MaintoolBar
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            background: isDarkMode
                ? 'rgba(9, 13, 17, 0.8) !important'
                : '#ffffff !important',
            backdropFilter: isDarkMode ? 'blur(15px)' : 'none',
            borderBottom: isDarkMode
                ? '1px solid rgba(0, 242, 255, 0.2)'
                : '1px solid #e0e0e0',
            boxShadow: isDarkMode
                ? '0 4px 20px rgba(0, 0, 0, 0.5)'
                : '0 2px 4px rgba(0,0,0,0.05)',
            color: isDarkMode ? '#ffffff' : '#333366',
            transition: 'all 0.3s ease',
        },
        flexOrgName: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: isDarkMode ? '#00f2ff' : '#333366',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            textShadow: isDarkMode ? '0 0 10px rgba(0, 242, 255, 0.5)' : 'none',
        },
        avatar: {
            cursor: 'pointer',
            background: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.4)' : '#e0e0e0'}`,
            display: 'grid',
            placeItems: 'center',
            transition: 'all 0.3s ease',
            '&:hover': {
                boxShadow: isDarkMode ? '0 0 12px rgba(0, 242, 255, 0.6)' : theme.shadows[2],
                background: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.08)',
            }
        },
        logoTitle: {
            color: isDarkMode ? '#00f2ff' : '#333366',
            fontWeight: 'bold'
        },
        languageSelect: {
            color: isDarkMode ? '#ffffff' : '#333366',
            marginRight: theme.spacing(2),
            marginLeft: theme.spacing(2),
            '&:before, &:after': {
                borderColor: isDarkMode ? 'rgba(0, 242, 255, 0.5) !important' : '#e0e0e0 !important',
            },
            '& .MuiSvgIcon-root': {
                color: isDarkMode ? '#00f2ff' : '#333366',
            }
        },
        badge: {
            '& .MuiBadge-badge': {
                backgroundColor: isDarkMode ? '#00f2ff' : '#333366',
                color: isDarkMode ? '#000' : '#fff',
                fontWeight: 'bold',
            }
        },
        iconButton: {
            color: isDarkMode ? '#ffffff' : '#333366',
            '&:hover': {
                color: isDarkMode ? '#00f2ff' : '#000000',
                background: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
            }
        },
        mobileMenu: {
            '& .MuiPaper-root': {
                backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
                border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#e0e0e0'}`,
                color: isDarkMode ? '#ffffff' : '#333366',
                backdropFilter: isDarkMode ? 'blur(10px)' : 'none',
            },
            '& .MuiMenuItem-root': {
                '&:hover': {
                    background: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
                }
            }
        },

        //SettingsDrawer
        drawerPaper: {
            width: 240, // Default width
            backgroundColor: isDarkMode ? 'rgba(15, 23, 30, 0.9) !important' : '#ffffff !important',
            backdropFilter: isDarkMode ? 'blur(20px)' : 'none',
            borderRight: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#e0e0e0'}`,
            display: 'flex',
            flexDirection: 'column',
            transition: 'all 0.3s ease',
            // High-level color management for nested items
            '& .MuiTypography-root': { color: isDarkMode ? '#ffffff' : '#333366' },
            '& .MuiSvgIcon-root': { color: isDarkMode ? '#ffffff' : '#333366' },
        },
        drawerPaperMobile: {
            top: '65px !important',
            height: 'auto',
            maxHeight: '78vh',
            width: 240,
            backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(25px)' : 'none',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#e0e0e0'}`,
            borderBottomLeftRadius: theme.spacing(2),
            boxShadow: isDarkMode ? '0 10px 30px rgba(0,0,0,0.8)' : theme.shadows[10],
            '& .MuiTypography-root': { color: isDarkMode ? '#ffffff' : '#333366' },
            '& .MuiSvgIcon-root': { color: isDarkMode ? '#ffffff' : '#333366' },
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0, 1),
            justifyContent: 'space-between',
            minHeight: 64,
            background: isDarkMode ? 'rgba(0, 242, 255, 0.03)' : '#f5f5f5',
        },
        drawerHeaderTitle: {
            fontWeight: 700,
            color: isDarkMode ? '#00f2ff !important' : 'inherit',
            marginLeft: theme.spacing(2),
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            letterSpacing: '1.2px',
        },
        mobileFooter: {
            position: 'fixed',
            bottom: 0,
            width: '100%',
            zIndex: 1200,
            background: isDarkMode ? '#090d11' : '#ffffff',
            borderTop: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#e0e0e0'}`,
        },
        toggleIcon: {
            color: isDarkMode ? '#00f2ff !important' : '#333366 !important',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
            }
        },
        divider: {
            backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.15)' : '#e0e0e0',
        },

        //ButtonsHistory
        desktopContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            width: '100%',
            padding: theme.spacing(0.5, 0),
            backgroundColor: isDarkMode ? 'rgba(10, 15, 20, 0.7)' : '#ffffff',
            backdropFilter: 'blur(10px)',
            borderTop: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'}`,
        },
        listItemDesktop: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '12px',
            color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : '#333366',
            padding: theme.spacing(1.5),
            minWidth: 70,
            transition: 'all 0.3s ease',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(51, 51, 102, 0.08)',
                color: isDarkMode ? '#00f2ff' : '#333366',
                '& $icon': { color: isDarkMode ? '#00f2ff' : '#333366' }
            },
        },
        selected: {
            color: isDarkMode ? '#00f2ff !important' : '#333366 !important',
            backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.15) !important' : 'rgba(51, 51, 102, 0.12) !important',
            boxShadow: isDarkMode ? 'inset 0 0 10px rgba(0, 242, 255, 0.1)' : 'none',
            '& $icon': {
                color: isDarkMode ? '#00f2ff' : '#333366',
                filter: isDarkMode ? 'drop-shadow(0 0 5px rgba(0, 242, 255, 0.5))' : 'none',
            },
            '& $textDesktop, & $textMobile': {
                fontWeight: 'bold',
                textShadow: isDarkMode ? '0 0 8px rgba(0, 242, 255, 0.4)' : 'none',
            }
        },
        icon: {
            color: isDarkMode ? '#ffffff' : '#333366',
            display: 'flex',
            justifyContent: 'center',
            margin: 0,
            minWidth: 'auto',
        },

        //EditItemView
        formWrapper: {
            width: '100%',
            maxWidth: 500,
            padding: theme.spacing(4),
            marginTop: theme.spacing(2),
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(20px)' : 'none',
            borderRadius: '24px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.15)' : '#e0e0e0'}`,
            boxShadow: isDarkMode
                ? '0 25px 50px rgba(0,0,0,0.5)'
                : '0 10px 25px rgba(0,0,0,0.05)',
            transition: 'all 0.3s ease',
        },
        buttons: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: theme.spacing(3),
            gap: theme.spacing(2)
        },
        cancelButton: {
            borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.3)' : '#333366',
            color: isDarkMode ? '#fff' : '#333366',
            '&:hover': {
                borderColor: isDarkMode ? '#fff' : '#000',
                backgroundColor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)'
            }
        },
        loading: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: isDarkMode ? 'rgba(9, 13, 17, 0.8)' : 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(8px)',
            transition: 'background 0.3s ease',
        },

        //ReportFilter
        gridContainer: {
            margin: theme.spacing(0, -1),
            '& > .MuiGrid-item': {
                padding: theme.spacing(1.5, 1)
            }
        },
        formControl: {
            '& .MuiFilledInput-root': {
                backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#f5f5f5',
                color: isDarkMode ? '#ffffff' : '#000000',
                borderRadius: '8px',
                border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#dddddd'}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                    backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.08)' : '#eeeeee',
                    borderColor: isDarkMode ? '#00f2ff' : '#000000',
                },
                '&.Mui-focused': {
                    backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#ffffff',
                    borderColor: isDarkMode ? '#00f2ff' : '#000000',
                },
                '&:before, &:after': { display: 'none' },
            },
            '& .MuiInputLabel-root': {
                color: isDarkMode ? 'rgba(0, 242, 255, 0.7)' : '#666666',
            },
            '& .MuiSelect-icon': {
                color: isDarkMode ? '#00f2ff' : '#333366',
            },
            '& .MuiSelect-selectMenu': {
                color: isDarkMode ? '#ffffff' : '#00fff',
            }
        },
        cyberButton: {
            borderColor: isDarkMode ? '#00f2ff' : '#333366',
            color: isDarkMode ? '#00f2ff' : '#333366',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : 'transparent',
            transition: 'all 0.3s ease',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.15)' : 'rgba(0, 0, 0, 0.04)',
                boxShadow: isDarkMode ? '0 0 10px rgba(0, 242, 255, 0.4)' : 'none',
                borderColor: isDarkMode ? '#00f2ff' : '#000000',
                color: isDarkMode ? '#00f2ff' : '#000000',
            },
            '&:disabled': {
                color: isDarkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.26)',
                borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.12)',
            }
        },

        //ReportLayoutPage
        filterWrapper: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(10px)' : 'none',
            padding: theme.spacing(2),
            borderRadius: '16px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : '#e0e0e0'}`,
            marginBottom: theme.spacing(3),
            boxShadow: isDarkMode ? 'none' : '0 4px 12px rgba(0,0,0,0.05)',
            transition: 'all 0.3s ease',
        },

        //EventReportPage
         menuItem: {
            backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
            color: isDarkMode ? '#ffffff' : '#333366',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
                color: isDarkMode ? '#00f2ff' : '#000000',
            },
            '&.Mui-selected': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.2)' : 'rgba(51, 51, 102, 0.08)',
                color: isDarkMode ? '#00f2ff' : '#333366',
                '&:hover': {
                    backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.3)' : 'rgba(51, 51, 102, 0.12)',
                }
            }
        },

        //NotificationsMenu
        menuPaper: {
            width: 360,
            maxHeight: 500,
            borderRadius: '16px',
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.9)' : 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(15px)',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
            boxShadow: isDarkMode ? '0 8px 32px 0 rgba(0, 0, 0, 0.8)' : '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-track': { background: 'rgba(255, 255, 255, 0.05)' },
            '&::-webkit-scrollbar-thumb': {
                background: isDarkMode ? 'rgba(0, 242, 255, 0.3)' : '#ccc',
                borderRadius: '10px',
            },
        },
        headerContainer: {
            position: 'sticky',
            top: 0,
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.95)' : '#ffffff',
            zIndex: 2,
            borderBottom: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'}`,
            padding: '8px',
        },
        removeAllButton: {
            color: '#ff4d4d',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: '8px 16px',
            borderRadius: '8px',
            width: '100%',
            fontSize: '0.875rem',
            transition: 'all 0.2s',
            border: '1px solid rgba(255, 77, 77, 0.2)',
            '&:hover': {
                backgroundColor: 'rgba(255, 77, 77, 0.1)',
                borderColor: '#ff4d4d',
                boxShadow: isDarkMode ? '0 0 10px rgba(255, 77, 77, 0.2)' : 'none',
            }
        },
        icons: {
            marginRight: '8px',
            fontSize: '1.2rem',
        },
        letters: {
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '1px',
        },
        menuItemNotifications: {
            padding: '12px 16px',
            borderBottom: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'}`,
            alignItems: 'flex-start',
            transition: 'background-color 0.2s ease',
            '&:last-child': { borderBottom: 'none' },
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
            }
        },
        notificationsList: {
            backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.03)' : 'rgba(0, 242, 255, 0.08)',
            borderLeft: `4px solid ${isDarkMode ? '#00f2ff' : '#00b8d4'}`,
            paddingLeft: '12px',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.08)' : 'rgba(0, 242, 255, 0.12)',
            },
        },
        notificationIconColor: {
            color: isDarkMode ? '#00f2ff' : '#00b8d4',
        },
        wrapping: {
            whiteSpace: 'normal',
            display: 'block',
            color: isDarkMode ? '#ffffff' : '#333333',
            fontSize: '0.9rem',
            lineHeight: 1.4,
            opacity: 0.9,
        },
        dateText: {
            display: 'block',
            fontSize: '0.75rem',
            color: isDarkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)',
            marginTop: '4px',
        },
        removeIconBtn: {
            padding: '8px',
            marginLeft: '4px',
            color: isDarkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
            '&:hover': {
                backgroundColor: 'rgba(255, 77, 77, 0.1)',
                color: '#ff4d4d',
            }
        },
        moreButtonContainer: {
            padding: '12px 8px',
            borderTop: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'}`,
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.5)' : '#f9f9f9',
        },
        moreButton: {
            color: isDarkMode ? '#00f2ff' : '#00b8d4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: '8px 16px',
            borderRadius: '8px',
            width: '100%',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : 'rgba(0, 184, 212, 0.2)'}`,
            transition: 'all 0.2s',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 184, 212, 0.05)',
                borderColor: isDarkMode ? '#00f2ff' : '#00b8d4',
                boxShadow: isDarkMode ? '0 0 10px rgba(0, 242, 255, 0.2)' : 'none',
            },
        },
        titleText: {
            color: isDarkMode ? '#00f2ff' : '#00b8d4',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
        },

        //EditCollectionView
        fab: {
            position: 'absolute',
            [theme.breakpoints.down('xs')]: {
                bottom: theme.spacing(10),
            },
            [theme.breakpoints.up('sm')]: {
                bottom: theme.spacing(2),
            },
            right: theme.spacing(2),
            backgroundColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            color: isDarkMode ? '#000' : '#fff',
            fontWeight: 'bold',
            boxShadow: isDarkMode ? '0 0 15px rgba(0, 242, 255, 0.6)' : theme.shadows[4],
            '&:hover': {
                backgroundColor: isDarkMode ? '#00c8d4' : theme.palette.primary.dark,
                boxShadow: isDarkMode ? '0 0 25px rgba(0, 242, 255, 0.8)' : theme.shadows[8],
                transform: 'scale(1.05)',
            },
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        },
        menu: {
            '& .MuiPaper-root': {
                backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.95)' : '#ffffff',
                backdropFilter: isDarkMode ? 'blur(15px)' : 'none',
                border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.3)' : '#e0e0e0'}`,
                color: isDarkMode ? '#ffffff' : '#333366',
                minWidth: '150px',
                borderRadius: '12px',
                boxShadow: isDarkMode ? '0 10px 30px rgba(0,0,0,0.5)' : theme.shadows[10],
            },
        },

        //RemoveDialog
        paperRemoveDialog: {
            borderRadius: 16,
            padding: theme.spacing(1),
            width: 320,
            textAlign: 'center',
            backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
            backgroundImage: isDarkMode
                ? 'linear-gradient(rgba(0, 242, 255, 0.03), rgba(0, 242, 255, 0.03))'
                : 'none',
            backdropFilter: 'blur(15px)',
            border: `1px solid ${isDarkMode ? 'rgba(255, 77, 77, 0.3)' : '#ff4d4d'}`,
            color: isDarkMode ? '#ffffff' : '#333333',
            boxShadow: isDarkMode ? '0 8px 32px 0 rgba(0, 0, 0, 0.8)' : theme.shadows[10],
        },
        iconRemoveDialog: {
            fontSize: 48,
            color: '#ff4d4d', // Cyber Red
            filter: isDarkMode ? 'drop-shadow(0 0 8px rgba(255, 77, 77, 0.5))' : 'none',
            marginBottom: theme.spacing(1.5),
        },
        actions: {
            justifyContent: 'center',
            padding: theme.spacing(2),
            gap: theme.spacing(1),
        },
        textField: {
            marginTop: theme.spacing(2),
            '& .MuiOutlinedInput-root': {
                color: isDarkMode ? '#ffffff' : '#333333',
                '& fieldset': { borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : '#cccccc' },
                '&:hover fieldset': { borderColor: '#00f2ff' },
                '&.Mui-focused fieldset': { borderColor: '#00f2ff' },
            },
            '& .MuiInputLabel-root': { color: isDarkMode ? 'rgba(255, 255, 255, 0.5)' : '#666666' },
            '& .MuiIconButton-root': { color: isDarkMode ? '#00f2ff' : theme.palette.primary.main },
        },
        loadingRemoveDialog: {
            position: 'fixed', inset: 0, zIndex: 9999, display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            backgroundColor: isDarkMode ? 'rgba(9, 13, 17, 0.8)' : 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(6px)',
        },
        cyberButtonRemoveDialog: {
            textTransform: 'uppercase',
            letterSpacing: '2px', // Increased for tech feel
            fontWeight: 'bold',
            borderRadius: '8px',
            transition: 'all 0.3s ease',
            position: 'relative',
        },
        cancelButtonRemoveDialog: {
            fontWeight: 'normal',
            fontSize: 'inherit',
            color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : '#666666',
            borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : '#cccccc',
            '&:hover': {
                color: isDarkMode ? '#ffffff' : '#000000',
                borderColor: isDarkMode ? '#ffffff' : '#333333',
                background: 'rgba(255, 255, 255, 0.05)',
            }
        },
        saveButtonRemoveDialog: {
            color: '#00f2ff',
            borderColor: 'rgba(0, 242, 255, 0.5)',
            background: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : 'transparent',
            boxShadow: '0 0 5px rgba(0, 242, 255, 0.2)',

            '&:hover': {
                color: '#333333',
                borderColor: '#00f2ff',
                background: 'rgba(0, 242, 255, 0.2)',
                boxShadow: '0 0 15px rgba(0, 242, 255, 0.6)',
                textShadow: '0 0 8px rgba(255, 255, 255, 0.8)',
            },
        },
        removeButton: {
            color: isDarkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)',
            transition: 'all 0.2s ease',
            '&:hover': {
                color: '#ff4444', // Cyber Red for deletion
                backgroundColor: 'rgba(255, 68, 68, 0.1)',
            }
        },
        dialogMessage: {
            fontWeight: 500,
            marginBottom: theme.spacing(1),
            color: isDarkMode ? '#ffffff' : '#1a1a1a',
            textAlign: 'center',
            textShadow: isDarkMode ? '0 0 5px rgba(255, 255, 255, 0.2)' : 'none',
        },

        //SearshDevices
        header: {
            zIndex: 6,
            position: 'relative',
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.85)' : 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(12px)',
            borderBottom: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
            [theme.breakpoints.up('sm')]: {
                paddingTop: theme.spacing(8),
            },
        },
        search: {
            position: 'relative',
            borderRadius: '50px',
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.3)' : 'rgba(0, 0, 0, 0.1)'}`,
            transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                borderColor: '#00f2ff',
            },
            '&:focus-within': {
                backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
                boxShadow: isDarkMode ? '0 0 15px rgba(0, 242, 255, 0.2)' : '0 4px 12px rgba(0,0,0,0.08)',
                borderColor: '#00f2ff',
            },
        },
        searchIcon: {
            padding: theme.spacing(0, 2),
            height: '100%',
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#00f2ff',
            zIndex: 1,
        },
        inputRoot: {
            color: isDarkMode ? '#ffffff' : '#333333',
            width: '100%',
        },
        inputInput: {
            padding: theme.spacing(1.2, 1, 1.2, 0),
            paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
            width: '100%',
            '&::placeholder': {
                color: isDarkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)',
                opacity: 1,
            },
        },
        filterPanel: {
            display: 'flex',
            flexDirection: 'column',
            padding: theme.spacing(3),
            gap: theme.spacing(2),
            minWidth: '320px',
            backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
            color: isDarkMode ? '#ffffff' : '#333333',
        },
        popoverPaper: {
            backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
            border: `1px solid ${isDarkMode ? '#00f2ff' : '#cccccc'}`,
            borderRadius: '12px',
            backdropFilter: isDarkMode ? 'blur(15px)' : 'none',
        },
        toggleButton: {
            color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.3)' : 'rgba(0, 0, 0, 0.1)'}`,
            borderRadius: '12px',
            backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : 'transparent',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.15)' : 'rgba(0, 0, 0, 0.05)',
                borderColor: '#00f2ff',
            }
        },
        plusIcon: {
            color: '#ffffff',
            background: 'linear-gradient(45deg, #00c6ff 30%, #0072ff 90%)',
            boxShadow: isDarkMode ? '0 0 15px rgba(0, 198, 255, 0.3)' : theme.shadows[2],
            transition: 'transform 0.2s',
            '&:hover': {
                transform: 'scale(1.1) rotate(90deg)',
                boxShadow: isDarkMode ? '0 0 20px rgba(0, 198, 255, 0.5)' : theme.shadows[4],
            },
            minWidth: '42px',
            minHeight: '42px',
        },

        //DevicesInfo
        tableContainer: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(12px)' : 'none',
            borderRadius: '16px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.15)' : '#e0e0e0'}`,
            boxShadow: isDarkMode ? '0 8px 32px 0 rgba(0, 0, 0, 0.8)' : theme.shadows[2],
            '& .MuiTableCell-head': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : '#f8f9fa',
                color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                borderBottom: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#e0e0e0'}`,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                fontWeight: 'bold',
            },
            '& .MuiTableCell-body': {
                color: isDarkMode ? '#ffffff' : '#333333',
                borderBottom: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#f0f0f0'}`,
            },
            '& .MuiIconButton-root': {
                color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : '#666666',
                '&:hover': {
                    color: '#00f2ff',
                    backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 242, 255, 0.05)'
                }
            }
        },
        redText: {
            color: '#ff4d4d !important',
            textShadow: isDarkMode ? '0 0 8px rgba(255, 77, 77, 0.6)' : 'none',
            fontWeight: 'bold',
        },
        actionPanel: {
            marginTop: theme.spacing(2),
            padding: theme.spacing(2),
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.8)' : '#ffffff',
            borderRadius: '12px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : '#e0e0e0'}`,
            boxShadow: isDarkMode ? 'none' : theme.shadows[1],
        },
        fixedBottomBar: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
            borderTop: `2px solid ${isDarkMode ? '#00f2ff' : theme.palette.primary.main}`,
            padding: theme.spacing(2),
            boxShadow: theme.shadows[6],
            zIndex: 100,
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
            flexDirection: 'column',
            alignItems: 'stretch',
            '& > *': {
                marginBottom: theme.spacing(1),
                width: '100%',
            },
        },

        //DeviceConnections
        linkFieldWrapper: {
            '& .MuiFormControl-root': {
                marginBottom: theme.spacing(2),
            },
            '& .MuiInputLabel-root': {
                color: isDarkMode ? 'rgba(0, 242, 255, 0.7)' : theme.palette.text.secondary,
            },
            '& .MuiFilledInput-root': {
                backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : '#dddddd'}`,
                borderRadius: '8px',
                color: isDarkMode ? '#ffffff' : '#333333',
                '&:hover': {
                    backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.05)',
                    borderColor: '#00f2ff',
                },
                '&.Mui-focused': {
                    backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : '#ffffff',
                    borderColor: '#00f2ff',
                },
            },
            '& .MuiChip-root': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.15)' : 'rgba(0, 242, 255, 0.1)',
                color: isDarkMode ? '#00f2ff' : theme.palette.primary.dark,
                border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.3)' : 'rgba(0, 242, 255, 0.5)'}`,
                fontWeight: 600,
            }
        },

        //DevicePage
        rootDevicePage: {
            background: isDarkMode
                ? 'radial-gradient(circle at 50% 50%, #0d161f 0%, #050a0f 100%)'
                : '#f5f5f7',
            minHeight: '100vh',
            paddingBottom: theme.spacing(4),
        },
        configue: {
            color: '#ff4d4d',
            textShadow: isDarkMode ? '0 0 8px rgba(255, 77, 77, 0.5)' : 'none',
            fontWeight: 'bold',
            marginBottom: theme.spacing(1),
        },
        cyberButtonSecondary: {
            borderColor: '#ff4d4d',
            color: '#ff4d4d',
            '&:hover': {
                backgroundColor: 'rgba(255, 77, 77, 0.1)',
                borderColor: '#ff4d4d',
            }
        },
        noDotsDisabled: {
            '& .MuiFilledInput-underline.Mui-disabled:before': {
                borderBottomStyle: 'none',
            },
        },
        dialogPaper: {
            backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
            border: `1px solid ${isDarkMode ? '#00f2ff' : '#cccccc'}`,
            color: isDarkMode ? '#ffffff' : '#333333',
            borderRadius: '16px',
        },

        //EditAttributesView
        addButton: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
            color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            borderColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            borderRadius: '8px',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
                borderColor: '#00f2ff',
                boxShadow: isDarkMode ? '0 0 10px rgba(0, 242, 255, 0.2)' : 'none',
            },
        },

        //CommandsPage
        drawerPaperOpen: {
            width: theme.dimensions?.drawerWidthDesktop || 240,
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.9) !important' : '#ffffff !important',
            backdropFilter: isDarkMode ? 'blur(10px)' : 'none',
            borderRight: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#e0e0e0'}`,
            display: 'flex',
            flexDirection: 'column',
            zIndex: theme.zIndex.drawer,
            transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        },
        drawerPaperClose: {
            width: 64,
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.9) !important' : '#ffffff !important',
            backdropFilter: isDarkMode ? 'blur(10px)' : 'none',
            borderRight: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#e0e0e0'}`,
            display: 'flex',
            flexDirection: 'column',
            zIndex: theme.zIndex.drawer,
            transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            overflowX: 'hidden',
        },
        tabItem: {
            minHeight: 48,
            borderRadius: theme.shape.borderRadius,
            marginBottom: theme.spacing(0.5),
            paddingLeft: theme.spacing(2),
            opacity: 0.7,
            // Dynamic text color
            color: isDarkMode ? '#ffffff' : theme.palette.text.primary,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            textTransform: 'none',
            maxWidth: '100%',
            '& .MuiTab-wrapper': {
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: '100%'
            },
            '& svg': {
                marginBottom: '0 !important',
                marginRight: theme.spacing(2),
                // Icon color: Neon Cyan in Dark, Primary in Light
                color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                minWidth: 24,
                // Only apply glow filter in Dark Mode
                filter: isDarkMode ? 'drop-shadow(0 0 5px rgba(0, 242, 255, 0.5))' : 'none',
            },
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
                opacity: 1,
            },
            '&.Mui-selected': {
                // Background of selected tab
                backgroundColor: isDarkMode
                    ? 'rgba(0, 242, 255, 0.15) !important'
                    : `${theme.palette.primary.main}14 !important`, // 14 is ~8% opacity in hex
                color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                opacity: 1,
                fontWeight: 600,
                '&:before': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    top: 8,
                    bottom: 8,
                    width: 4,
                    borderRadius: '0 4px 4px 0',
                    backgroundColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                    // Glow effect only for Dark Mode
                    boxShadow: isDarkMode ? '0 0 10px #00f2ff' : 'none',
                }
            }
        },
        formWrapperDesktop: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.03)' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(15px)' : 'none',
            padding: theme.spacing(4),
            borderRadius: '20px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : '#e0e0e0'}`,
            boxShadow: isDarkMode ? '0 8px 32px 0 rgba(0, 0, 0, 0.37)' : theme.shadows[2],
            minHeight: 400,
            display: 'flex',
            flexDirection: 'column',
        },
        formWrapperMobile: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#ffffff',
            padding: theme.spacing(3),
            borderRadius: '15px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : '#e0e0e0'}`,
            minHeight: 80,
            display: 'flex',
            flexDirection: 'column',
            boxShadow: isDarkMode ? 'none' : theme.shadows[1],
        },
        inputField: {
            marginBottom: theme.spacing(3),
            marginTop: theme.spacing(1),
            width: '100%',
            maxWidth: 500,
            '& .MuiOutlinedInput-root': {
                color: isDarkMode ? '#ffffff' : '#000000',
                '& fieldset': {
                    borderColor: isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#dddddd'
                },
                '&:hover fieldset': {
                    borderColor: isDarkMode ? 'rgba(0, 242, 255, 0.5)' : '#999999'
                },
                '&.Mui-focused fieldset': {
                    borderColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main
                },
            },
            '& .MuiInputLabel-root': {
                color: isDarkMode ? 'rgba(255, 255, 255, 0.5)' : '#666666'
            },
            '& .MuiSelect-icon': {
                color: isDarkMode ? '#00f2ff' : theme.palette.primary.main
            }
        },
        sendButton: {
            padding: theme.spacing(1.5, 6),
            textTransform: "none",
            fontWeight: 'bold',
            background: isDarkMode
                ? 'linear-gradient(45deg, #00c6ff 30%, #0072ff 90%)'
                : theme.palette.primary.main,
            color: '#ffffff',
            boxShadow: isDarkMode ? '0 0 15px rgba(0, 198, 255, 0.4)' : theme.shadows[2],
            borderRadius: '10px',
            '&:hover': {
                background: isDarkMode
                    ? 'linear-gradient(45deg, #00c6ff 30%, #0072ff 90%)'
                    : theme.palette.primary.dark,
                boxShadow: isDarkMode ? '0 0 25px rgba(0, 198, 255, 0.6)' : theme.shadows[4],
            }
        },
        mobileTabContainer: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#f0f0f0',
            marginBottom: theme.spacing(2),
            borderRadius: '10px',
            '& .MuiTab-root': { color: isDarkMode ? '#ffffff' : '#333366' }
        },
        sectionTitle: {
            color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            fontWeight: 600,
            marginBottom: theme.spacing(2),
        },

        //Dashboard
        pageTitle: {
            fontWeight: 800, // Slightly bolder for impact
            color: isDarkMode ? '#00f2ff' : '#003366',
            textTransform: 'uppercase',
            letterSpacing: '3px',
            textShadow: isDarkMode
                ? '0 0 10px rgba(0, 242, 255, 0.7), 0 0 20px rgba(0, 242, 255, 0.3)'
                : 'none',
        },
        infoCard: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: theme.spacing(2.5),
            borderRadius: '16px',
            background: isDarkMode
                ? 'radial-gradient(circle at top left, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)'
                : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(12px)' : 'none',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.15)' : 'rgba(0, 0, 0, 0.08)'}`,
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
            cursor: 'pointer',
            transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
            boxShadow: isDarkMode
                ? '0 4px 20px rgba(0, 0, 0, 0.4)'
                : '0 2px 12px rgba(0, 0, 0, 0.04)',
            '&:hover': {
                transform: 'translateY(-6px)',
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : '#ffffff',
                borderColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                boxShadow: isDarkMode
                    ? '0 0 25px rgba(0, 242, 255, 0.25)'
                    : '0 12px 24px rgba(0, 0, 0, 0.08)',
            },
        },
        infoCardLabel: {
            fontSize: '0.75rem',
            fontWeight: 600,
            color: isDarkMode ? 'rgba(0, 242, 255, 0.6)' : 'rgba(0, 51, 102, 0.6)',
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            marginBottom: theme.spacing(0.5),
        },
        infoCardValue: {
            fontSize: '1.75rem',
            fontWeight: 900,
            color: isDarkMode ? '#ffffff' : '#1a1a1a',
            letterSpacing: '-0.5px',
        },
        kpiSelectorContainer: {
            padding: theme.spacing(3),
            marginBottom: theme.spacing(3),
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
            borderRadius: '20px',
            border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'}`,
        },
        kpiCircleCard: {
            textAlign: 'center',
            padding: theme.spacing(3),
            borderRadius: '24px',
            background: isDarkMode
                ? 'linear-gradient(145deg, #0d161f 0%, #050a0f 100%)'
                : '#ffffff',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.06)'}`,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: isDarkMode ? 'none' : '0 4px 10px rgba(0,0,0,0.03)',
            '&:hover': {
                transform: 'scale(1.02)',
                borderColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                boxShadow: isDarkMode ? '0 0 30px rgba(0, 242, 255, 0.15)' : '0 6px 15px rgba(0,0,0,0.08)',
            },
        },
        kpiCircle: {
            width: 120,
            height: 120,
            borderRadius: '50%',
            border: `2px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : 'rgba(0, 51, 102, 0.1)'}`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: theme.spacing(2),
            backgroundColor: isDarkMode ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.02)',
            position: 'relative',
            boxShadow: isDarkMode ? 'inset 0 0 15px rgba(0, 242, 255, 0.05)' : 'none',
            '&:after': isDarkMode ? {
                content: '""',
                position: 'absolute',
                top: -5, left: -5, right: -5, bottom: -5,
                borderRadius: '50%',
                border: '1px solid rgba(0, 242, 255, 0.1)',
                animation: '$pulse 2s infinite',
            } : {},
        },
        kpiValue: {
            fontWeight: 800,
            fontSize: '1.8rem',
            color: isDarkMode ? '#00f2ff' : '#003366',
            textShadow: isDarkMode ? '0 0 12px rgba(0, 242, 255, 0.5)' : 'none',
        },
        kpiUnit: {
            fontSize: '0.8rem',
            fontWeight: 600,
            color: isDarkMode ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.4)',
            textTransform: 'uppercase',
        },
        kpiLabel: {
            fontSize: '0.95rem',
            fontWeight: 600,
            color: isDarkMode ? '#ffffff' : '#1a1a1a',
            marginTop: theme.spacing(1),
        },
        reportCard: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.spacing(2.5),
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.03)' : '#ffffff',
            borderRadius: '15px',
            border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.06)'}`,
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            height: '100%',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 51, 102, 0.05)',
                borderColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            },
        },
        reportIconContainer: {
            width: 50,
            height: 50,
            borderRadius: '12px',
            backgroundColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            boxShadow: isDarkMode ? '0 0 15px rgba(0, 242, 255, 0.3)' : 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: theme.spacing(1.5),
        },
        reportIcon: {
            fontSize: 26,
            color: isDarkMode ? '#0a0e14' : '#ffffff',
        },
        reportLabel: {
            fontSize: '0.85rem',
            fontWeight: 600,
            color: isDarkMode ? '#ffffff' : '#1a1a1a',
        },
        dividerDashboard: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)',
            margin: theme.spacing(4, 0),
        },
        fullPageLoader: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
            color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
        },
        kpiSelectorTitle: {
            fontWeight: 700,
            // Dynamic color: Neon Cyan in Dark, Deep Navy in Light
            color: isDarkMode ? '#00f2ff' : '#003366',
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            // Matches the glowing effect from your SettingsDrawer
            textShadow: isDarkMode ? '0 0 10px rgba(0, 242, 255, 0.5)' : 'none',
            transition: 'color 0.3s ease, text-shadow 0.3s ease',
        },

        customRangeInput: {
            '& .MuiInputLabel-root': {
                color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
            },
            '& .MuiOutlinedInput-input': {
                color: isDarkMode ? '#fff' : '#000',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
                },
            },
        },
        periodMenuPaper: {
            minWidth: 300,
            padding: 8,
            backgroundColor: isDarkMode ? '#1a222c' : '#ffffff',
            color: isDarkMode ? '#fff' : '#000',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
            boxShadow: isDarkMode ? '0 10px 30px rgba(0,0,0,0.5)' : theme.shadows[5],
        },
        goButton: {
            backgroundColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            color: isDarkMode ? '#000' : '#fff',
            fontWeight: 'bold',
            '&:hover': {
                backgroundColor: isDarkMode ? '#00d4e0' : theme.palette.primary.dark,
            }
        },

        //AddAttributeDialog
        dialogActionBtn: {
            fontWeight: 700,
            letterSpacing: '1px',
            padding: theme.spacing(1, 3),
            margin: theme.spacing(1),
            color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            '&.Mui-disabled': {
                color: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
            },
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
            }
        },
        cancelBtn: {
            color: isDarkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)',
            '&:hover': {
                color: '#ff4444',
            }
        },

        //DevicesList
        sidebar: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: isDarkMode ? 'rgba(10, 15, 20, 0.9)' : '#f0f2f5',
            backdropFilter: isDarkMode ? 'blur(15px)' : 'none',
            borderRight: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.15)' : 'rgba(0, 0, 0, 0.05)'}`,
            [theme.breakpoints.up('sm')]: {
                position: 'fixed',
                left: 0,
                top: 0,
                height: `calc(90% - ${theme.spacing(3)})`,
                width: theme.dimensions.drawerWidthDesktop,
                zIndex: 3,
                boxShadow: isDarkMode ? '5px 0 20px rgba(0,0,0,0.5)' : theme.shadows[3],
            },
        },
        middleDesktop: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            maxHeight: '73vh',
            zIndex: 4,
        },
        middle: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            backgroundColor: isDarkMode ? 'transparent' : '#ffffff',
            maxHeight: '55vh',
            zIndex: 4,
            '&::-webkit-scrollbar': { width: '4px' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: isDarkMode ? '#00f2ff' : '#ccc' }
        },
        deviceCard: {
            margin: theme.spacing(1.5),
            borderRadius: '16px',
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.03)' : '#ffffff',
            border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'}`,
            transition: 'all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)',
            overflow: 'hidden',
            '&:hover': {
                transform: 'translateX(4px)',
                borderColor: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                boxShadow: isDarkMode ? '0 0 15px rgba(0, 242, 255, 0.1)' : theme.shadows[4],
            },
        },
        textWrapper: {
            '& .MuiListItemText-primary': {
                color: isDarkMode ? '#ffffff' : '#1a1a1a',
            },
            '& .MuiListItemText-secondary': {
                color: isDarkMode ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.6)',
            }
        },
        signalIcon: {
            fontSize: '22px',
            transition: 'transform 0.2s ease-in-out, filter 0.2s',
            filter: isDarkMode ? 'drop-shadow(0 0 5px rgba(255,255,255,0.1))' : 'none',
            '&:hover': {
                transform: 'scale(1.2)',
            },
        },
        moreIcon: {
            color: isDarkMode ? 'rgba(0, 242, 255, 0.6)' : '#333366',
            padding: theme.spacing(1),
            borderRadius: '8px',
            transition: 'all 0.2s ease',
            '&:hover': {
                color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
                // Enhancement: Cyberpunk "Scan" line effect on hover
                boxShadow: isDarkMode ? 'inset 0 0 8px rgba(0, 242, 255, 0.2)' : 'none',
            },
            '& .MuiSvgIcon-root': {
                fontSize: '22px',
            }
        },
        statusTextContainer: {
            margin: theme.spacing(1, 1.25),
            '& .MuiListItemText-secondary': {
                color: isDarkMode ? 'rgba(0, 242, 255, 0.6)' : '#333366',
                fontSize: '0.75rem',
                fontFamily: 'monospace',
                marginTop: '2px',
            }
        },

        //StatusView
        statusCard: {
            maxWidth: 345,
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.9)' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(12px)' : 'none',
            borderRadius: '20px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
            boxShadow: isDarkMode ? '0 8px 32px rgba(0, 0, 0, 0.5)' : theme.shadows[5],
            overflow: 'hidden',
        },
        statusCardContent: {
            color: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.7)',
            '& b': {
                color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                marginRight: theme.spacing(0.5),
            },
            '& a': {
                color: isDarkMode ? '#00f2ff !important' : 'blue !important',
                textDecoration: 'none',
                borderBottom: '1px dashed currentColor',
                '&:hover': {
                    filter: 'brightness(1.2)',
                }
            }
        },
        shareDrawer: {
            '& .MuiPaper-root': {
                borderTopLeftRadius: '24px',
                borderTopRightRadius: '24px',
                backgroundColor: isDarkMode ? 'rgba(20, 30, 40, 0.98)' : '#fff',
                backdropFilter: 'blur(20px)',
                color: isDarkMode ? '#fff' : '#000',
            }
        },
        socialIconContainer: {
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#f0f0f0',
            transition: 'transform 0.2s',
            '&:hover': {
                transform: 'scale(1.1)',
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : '#e0e0e0',
            }
        },

        //PositionPage
        pageBackground: {
            backgroundColor: isDarkMode ? '#080c11' : '#f4f7f9',
            minHeight: '100vh',
        },
        backButton: {
            marginRight: theme.spacing(2),
            color: isDarkMode ? '#00f2ff' : theme.palette.text.primary,
            backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : 'transparent',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.15)' : 'rgba(0, 0, 0, 0.04)',
                transform: 'translateX(-3px)',
            },
        },
        headerTitle: {
            fontWeight: 900,
            color: isDarkMode ? '#fff' : '#000',
            textTransform: 'uppercase',
            letterSpacing: '2px',
        },
        label: {
            fontWeight: 700,
            color: isDarkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)',
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            letterSpacing: '1px',
        },
        value: {
            fontWeight: 600,
            color: isDarkMode ? '#00f2ff' : theme.palette.primary.dark,
            textAlign: 'right',
            fontFamily: 'monospace',
            textShadow: isDarkMode ? '0 0 8px rgba(0, 242, 255, 0.3)' : 'none',
        },

        //ReplayPageGoogleMap
        controlContent: {
            padding: theme.spacing(2),
            marginBottom: theme.spacing(2),
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.85)' : 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
            boxShadow: isDarkMode ? '0 0 20px rgba(0, 0, 0, 0.4)' : theme.shadows[4],
        },
        timeDisplay: {
            fontStyle: 'italic',
            fontFamily: 'monospace',
            color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'gray',
            fontSize: '0.8rem',
            marginTop: theme.spacing(1),
        },
        accordionReplay: {
            marginBottom: theme.spacing(2),
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.85)' : 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(10px)',
            borderRadius: '12px !important',
            border: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'}`,
            boxShadow: 'none',
            '&:before': { display: 'none' }, // Remove default Material UI line
        },
        accordionSummary: {
            color: isDarkMode ? '#00f2ff' : theme.palette.text.primary,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '1px',
        },
        replaySlider: {
            color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
            '& .MuiSlider-thumb': {
                boxShadow: isDarkMode ? '0 0 10px rgba(0, 242, 255, 0.8)' : 'none',
            },
            '& .MuiSlider-rail': {
                opacity: 0.3,
            }
        },
        controlsRow: {
            display: 'flex',
            alignItems: 'center',
            // justifyContent: 'space-between',
            // gap: theme.spacing(1),
            // marginTop: theme.spacing(1),
        },
        backButtonReplay: {
            position: 'absolute',
            [theme.breakpoints.up('sm')]: {
                top: theme.spacing(15),
            },
            [theme.breakpoints.down('sm')]: {
                top: theme.spacing(7),
            },
            left: theme.spacing(1),
            zIndex: 1000,
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.85)' : 'rgba(255, 255, 255, 0.8)',
            '&:hover': { backgroundColor: '#fff' },
        },

        //GeofencesPage
        geofenceRoot: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: isDarkMode ? '#080c11' : '#f4f7f9',
        },
        geofenceContent: {
            flexGrow: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column-reverse',
            }
        },
        geofenceDrawerPaper: {
            position: 'relative',
            backgroundColor: isDarkMode ? 'rgba(10, 15, 20, 0.9)' : '#ffffff',
            backdropFilter: isDarkMode ? 'blur(15px)' : 'none',
            borderRight: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.15)' : 'rgba(0, 0, 0, 0.08)'}`,
            boxShadow: isDarkMode ? '10px 0 30px rgba(0,0,0,0.5)' : theme.shadows[3],
            overflow: 'hidden', // Keeps child components inside the rounded cyber container
            [theme.breakpoints.up('sm')]: {
                width: 350,
            },
            [theme.breakpoints.down('xs')]: {
                height: 250,
                borderRight: 'none',
                borderTop: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.15)' : 'rgba(0, 0, 0, 0.08)'}`,
            }
        },
        mapContainer: {
            flexGrow: 1,
            backgroundColor: isDarkMode ? '#000' : '#eee', // Dark base for map loading
        },

        //GeofenceView
        geofenceList: {
            width: '100%',
            overflowY: 'auto',
            padding: 0,
        },
        geofenceListItem: {
            padding: theme.spacing(1, 2),
            borderBottom: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'}`,
            transition: 'all 0.2s ease',
            '&:last-child': {
                borderBottom: 'none',
            },
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                '& .MuiListItemText-primary': {
                    color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
                }
            },
            // Ensuring the text matches the HUD aesthetic
            '& .MuiListItemText-primary': {
                fontSize: '0.9rem',
                fontWeight: 600,
                color: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'inherit',
            }
        },
        geofenceIcon: {
            width: '25px',
            height: '25px',
            // Uses your existing filter logic but fits the theme
            filter: isDarkMode ? 'brightness(0) invert(1) drop-shadow(0 0 2px #00f2ff)' : 'none',
        },

        //StartStopView
        titleStartStopView: {
            fontWeight: 'bold',
            minWidth: theme.spacing(10),
            marginRight: theme.spacing(1),
            fontSize: 'inherit',
            color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
        },
        nameDeviceStartStopView: {
            fontWeight: 'bold',
            fontSize: '0.8rem',
            marginBottom: theme.spacing(1),
            textAlign: 'center',
            color: isDarkMode ? '#00f2ff' : theme.palette.primary.main,
        },

        //DevicesDrawer
        collapseBar: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            backgroundColor: isDarkMode ? 'rgba(0, 0, 0, 0)' : '#ffffff',
        },

        //ButtonsHistoryMobile
        mobileContainer: {
            display: 'flex',
            justifyContent: 'space-around',
            padding: 0,
            backgroundColor: isDarkMode ? 'rgba(13, 22, 31, 0.95)' : '#ffffff',
            borderTop: `1px solid ${isDarkMode ? 'rgba(0, 242, 255, 0.2)' : '#dddddd'}`,
        },
        mobileItem: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: theme.spacing(1, 0),
            color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : '#666666',
            flex: 1,
            '&.Mui-selected': {
                color: '#00f2ff',
                backgroundColor: 'transparent !important',
                '& $iconMobile': {
                    filter: isDarkMode ? 'drop-shadow(0 0 5px #00f2ff)' : 'none',
                }
            }
        },
        iconMobile: {
            minWidth: 'auto',
            marginBottom: 4,
            color: 'inherit',
            '& svg': { fontSize: '1.4rem' }
        },
        textDesktop: {
            fontSize: '0.7rem',
            textAlign: 'center',
            marginTop: theme.spacing(0.5),
            color: 'inherit',
            fontWeight: 500,
        },
        textMobile: {
            fontSize: '0.65rem',
            textAlign: 'center',
            color: isDarkMode ? '#00f2ff' : 'inherit',
            fontWeight: 500,
            opacity: 0.9
        },
        iconMenuItemColor: {
            color: isDarkMode ? '#00f2ff !important' : '#333366 !important',
        },

        //ReportNavbar
        appBarReport: {
        backgroundColor: isDarkMode ? 'rgba(20, 30, 35, 0.6)' : 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(12px) saturate(150%)',
            borderRadius: '16px',
            margin: theme.spacing(0),
            width: `calc(100% - ${theme.spacing(0)}px)`,
            border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.05)'}`,
            boxShadow: isDarkMode ? '0 8px 32px 0 rgba(0, 0, 0, 0.5)' : '0 4px 12px 0 rgba(0, 0, 0, 0.1)',
            top: theme.spacing(0),
            left: 0,
            right: 0,
            transition: 'all 0.3s ease',
        },
        toolbar: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
            minHeight: '64px',
        },
        menuButton: {
            zIndex: 2,
            transition: 'all 0.3s',
            color: isDarkMode ? '#00f2ff' : 'inherit',
            '&:hover': {
                backgroundColor: isDarkMode ? 'rgba(0, 242, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
                transform: 'rotate(90deg)',
            },
        },
        sideIcons: {
            display: 'flex',
            alignItems: 'center',
            minWidth: 48,
        },
        reportTitleText: {
            fontWeight: 500,
            fontSize: '1.1rem',
            letterSpacing: '0.5px',
            color: isDarkMode ? '#00f2ff' : 'inherit',
            fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        },
        centerLoader: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '300px',
            width: '100%',
        },

        //StatusView
        paperSocialMedia: {
            backgroundColor: isDarkMode ? '#0d161f' : '#ffffff',
            backgroundImage: isDarkMode
                ? `linear-gradient(to bottom, rgba(0, 242, 255, 0.05), rgba(13, 17, 23, 1))`
                : 'none',
        },
        color: {
          color: isDarkMode? '#00f2ff' : '#333366'
        },
    };
};